export default __webpack_public_path__ + "static/media/fish&chips-bolditalic.a130ccd9.eot";